import React, { LegacyRef, ReactNode } from 'react'
import { classesBuilder } from 'shared/utils'

type WrapFieldType = {
  body?: ReactNode
  children?: ReactNode
  className?: string
  footer?: ReactNode
  header?: ReactNode
  label?: string
  required?: boolean
  requiredSign?: boolean
  style?: { [key: string]: string }
  textHelper?: string
  textHelperTop?: boolean
  wrapperRef?: { current: HTMLDivElement | null }
}

const WrapField: React.FC<WrapFieldType> = ({
  body,
  children,
  className,
  footer,
  header,
  label,
  required,
  requiredSign,
  style = {},
  textHelper,
  textHelperTop,
  wrapperRef,
}) => (
  <div className={className} ref={wrapperRef as LegacyRef<HTMLDivElement>}>
    <div>
      <div className={classesBuilder(style, { header: true })}>
        {label && (
          <span className={classesBuilder(style, { label: true })}>
            {label}
            {(requiredSign || required) && <span className={classesBuilder(style, { requiredSign: true })}>*</span>}
          </span>
        )}

        {header}
      </div>

      {textHelperTop && <div className={classesBuilder(style, { textHelper: true })}>{textHelper}</div>}

      <div className={classesBuilder(style, { container: true })}>{children || body}</div>
    </div>

    {footer}

    {textHelperTop || <div className={classesBuilder(style, { textHelper: true })}>{textHelper}</div>}
  </div>
)

export default WrapField
